import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/icon_time.svg'
import _imports_1 from '@/assets/svg/icon_nearby.svg'
import _imports_2 from '@/assets/svg/icon_location.svg'


const _hoisted_1 = { class: "w-[390px] border-[3px] border-[var(--primary-color)] px-[36px] py-[76px] rounded-[100px]" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "pl-12 mb-9" }
const _hoisted_4 = { class: "pl-12 mb-9" }
const _hoisted_5 = { class: "flex gap-x-4 px-3 mb-9" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-[27px]"
}, null, -1)
const _hoisted_7 = { class: "flex gap-x-4 px-3 mb-9" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[27px]"
}, null, -1)
const _hoisted_9 = { class: "flex gap-x-4 px-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-[27px]"
}, null, -1)

import BaseButton from '@/components/common/BaseButton.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'Reservation',
  props: {
    excursion: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;



const goToForm = () => emit('click');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseTypography, {
          text: _ctx.excursion?.data?.attributes.summForGroup,
          type: "subtitle",
          color: "var(--secondary-color)",
          tag: "span"
        }, null, 8, ["text"]),
        _createVNode(BaseTypography, {
          text: " ₽/чел",
          type: "body2",
          tag: "span"
        }),
        _createVNode(BaseTypography, {
          text: _ctx.excursion?.data?.attributes.group,
          type: "body"
        }, null, 8, ["text"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(BaseTypography, {
          text: _ctx.excursion?.data?.attributes.summForInd,
          type: "subtitle",
          color: "var(--secondary-color)",
          tag: "span"
        }, null, 8, ["text"]),
        _createVNode(BaseTypography, {
          text: " ₽/чел",
          type: "body2",
          tag: "span"
        }),
        _createVNode(BaseTypography, {
          text: _ctx.excursion?.data?.attributes.excursionType,
          type: "body"
        }, null, 8, ["text"])
      ]),
      _createVNode(BaseButton, {
        text: "Забронировать",
        type: "subtitle4",
        color: "var(--base-white)",
        ui: "primary-with-back",
        class: "cursor-pointer mb-9",
        onClick: goToForm
      }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: "Продолжительность:",
            type: "body2"
          }),
          _createVNode(BaseTypography, {
            text: _ctx.excursion?.data?.attributes.duration,
            type: "body"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: "Место встречи:",
            type: "body2"
          }),
          _createVNode(BaseTypography, {
            text: _ctx.excursion?.data?.attributes.meetLocation,
            type: "body"
          }, null, 8, ["text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", null, [
          _createVNode(BaseTypography, {
            text: "Место окончания:",
            type: "body2"
          }),
          _createVNode(BaseTypography, {
            text: _ctx.excursion?.data?.attributes.endLocation,
            type: "body"
          }, null, 8, ["text"])
        ])
      ])
    ])
  ]))
}
}

})